import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApiService, sioConnect } from "../component/services/apiService";
import {TokenService} from "../component/services/tokenService.js";

const user = JSON.parse(sessionStorage.getItem("user"));

export const login = createAsyncThunk(
	"auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
		const response = await ApiService.login(email, password);
		if (response.data.token) { 
			sioConnect(response.data.token);
			TokenService.setUser(response.data);
		}
      	return { user: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
	await ApiService.logout();
});

const initialState = user ? { isLoggedIn: true, user } : {isLoggedIn: false, user: null}

export const authSlice = createSlice({
	name: "auth",
	initialState,
	extraReducers: {
		[login.fulfilled]: (state, action) => {
			state.isLoggedIn = true;
			state.user = action.payload.user;
		},
		[login.rejected]: (state, action) => {
			state.isLoggedIn = false;
			state.user = null;
		},
		[logout.rejected]: (state, action) => {
			state.isLoggedIn = false;
			state.user = null;
		},
		[logout.fulfilled]: (state, action) => {
			state.isLoggedIn = false;
			state.user = null;
		},
	}
})

export default authSlice.reducer;